/**
 * Safely unwraps array responses that might either be bare arrays or wrapped in an envelope.
 */
export function unwrapArrayResponse<T>(
  response: unknown,
  key?: string
): T[] {
  if (Array.isArray(response)) {
    return response as T[];
  }

  if (
    response &&
    typeof response === "object" &&
    key &&
    Array.isArray((response as Record<string, unknown>)[key])
  ) {
    return (response as Record<string, unknown>)[key] as T[];
  }

  return [];
}
